import React, { useEffect, useState } from 'react'
import { Checkbox } from 'components/forms'

export const useFilterCardRemote = (value, onChange, clearValueFromParent, startAllInactive) => {
	const [itemArr, setItemArr] = useState(value)
	const [showModal, setShowModal] = useState(false)
	const isAllActive = !itemArr.length
	const activeMap = itemArr.reduce((acc, item) => {
		acc[item.id] = true
		return acc
	}, {})
	useEffect(() => {
		return () => {
			setItemArr([])
		}
	}, [clearValueFromParent])

	const handleSave = () => {
		setShowModal(false)
		onChange(itemArr.map(({ id }) => id))
	}

	const handleAllActiveClick = e => {
		if(!isAllActive) {
			setItemArr([])
		}
	}

	const handleClick = (original) => {
		setItemArr(oldArr => {
			return activeMap[original.id] ? oldArr.filter(item => item.id !== original.id) : [...oldArr, original]
		})
	}
	const handleRemoveItem = ({ id }) => {
		const newValues = itemArr.filter(item => id !== item.id)
		setItemArr(newValues)
		onChange(newValues.map(item => item.id))
	}
	const columns = (t) => ([
		{
			Header: t('common.fields.code'),
			accessor: 'code',
			Cell: ({ value: cellValue, original }) => <Checkbox noForm readOnly checked={activeMap[original.id] || (!startAllInactive && isAllActive)} label={cellValue}/>
		}, {
			Header: t('common.fields.name'),
			accessor: 'name'
		}
	])
	const methods = {
		itemArr,
		setItemArr,
		handlerItems: (allItemsLabel) => itemArr.length ? itemArr : [{ name: allItemsLabel }],
		handlerCheckAll: () => isAllActive,
		handlerRemoveItem: () => value.length ? handleRemoveItem : null

	}
	return { handleSave, handleAllActiveClick, handleClick, showModal, setShowModal, methods, columns }
}

